import React, { Component } from 'react'
import { compose } from 'redux'
import CSSModules from 'helpers/CSSModulesUtil'
import { Table, TableCell, TableRow, TableHead } from 'react-toolbox/lib/table'
import styles from '../styles.scss'


class AeResourcesTable extends Component {
  render() {
    const {
      categories,
      tableData
    } = this.props

    return (
      <Table selectable={false} theme={styles}>
        <TableHead>
          {categories.map((category, index) => <TableCell key={index}>{category}</TableCell>)}
        </TableHead>
        {tableData.map((row, index) =>
          <TableRow key={index}>
            {row.map((data, idx) => (
              <TableCell key={idx}>{data}</TableCell>
            ))}
          </TableRow>
        )}
      </Table>
    )
  }
}

const withStyles = CSSModules(styles)
const enhance = compose(
  withStyles
)

export default enhance(AeResourcesTable)

